import createList from '../../with-list';

import endpoints from '../../../../config/endpoints';

const namespace = 'blogArticleCommentList';

const { actions, selectors, reducers } = createList({
	namespace,
	url: endpoints.BLOG.ARTICLE_COMMENTS,
	perPage: 50
});

export { namespace, actions, selectors, reducers as default };


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article-comment/list/index.js